import { useEffect, useState } from "react";

export const useNow = (intervalMs = 1000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(new Date());
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [intervalMs]);

  return now;
};
